
import { InvoiceSettings } from '../types';

export const sendEmailAPI = async (
    recipient: string,
    subject: string,
    body: string,
    settings: InvoiceSettings,
    attachmentBase64?: string,
    attachmentName?: string
): Promise<{ success: boolean; error?: string }> => {
    if (!settings.appsScriptUrl) return { success: false, error: 'Chưa cấu hình URL Google Apps Script.' };

    try {
        const formData = new URLSearchParams();
        formData.append('email', recipient);
        formData.append('subject', subject);
        formData.append('htmlBody', body);
        if (settings.senderName) formData.append('senderName', settings.senderName);
        if (attachmentBase64 && attachmentName) {
            formData.append('attachmentBase64', attachmentBase64);
            formData.append('attachmentName', attachmentName);
            formData.append('attachmentMimeType', 'application/pdf');
        }

        const response = await fetch(settings.appsScriptUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData,
        });

        if (!response.ok) return { success: false, error: `Server error: ${response.status}` };
        return { success: true };
    } catch (e: any) {
        return { success: false, error: e.message };
    }
};

export const sendResetPasswordEmail = async (
    recipient: string,
    resetLink: string,
    settings: InvoiceSettings
) => {
    const subject = "Yêu cầu đặt lại mật khẩu - QHome";
    const body = `
        <div style="font-family: sans-serif; padding: 20px; border: 1px solid #eee; border-radius: 10px; max-width: 600px; margin: 0 auto;">
            <h2 style="color: #2563eb;">Yêu cầu đặt lại mật khẩu</h2>
            <p>Chào bạn,</p>
            <p>Chúng tôi nhận được yêu cầu đặt lại mật khẩu cho tài khoản của bạn tại QHome.</p>
            <p>Vui lòng nhấn vào nút bên dưới để đặt lại mật khẩu về mặc định (123456a):</p>
            <div style="margin: 30px 0; text-align: center;">
                <a href="${resetLink}" style="background-color: #2563eb; color: white; padding: 12px 24px; text-decoration: none; border-radius: 5px; font-weight: bold; display: inline-block;">Đặt lại mật khẩu</a>
            </div>
            <p>Nếu bạn không yêu cầu điều này, vui lòng bỏ qua email này.</p>
            <hr style="border: 0; border-top: 1px solid #eee; margin: 20px 0;" />
            <p style="font-size: 12px; color: #666;">Đây là email tự động, vui lòng không trả lời.</p>
        </div>
    `;
    return sendEmailAPI(recipient, subject, body, settings);
};
